var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPhantom = function SvgPhantom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1200 1200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#phantom_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#AB9FF2",
    d: "M0-.001h1200v1200H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M522.218 764.813c-47.117 72.198-126.071 163.564-231.129 163.564-49.664 0-97.418-20.445-97.418-109.256 0-226.179 308.808-576.309 595.332-576.309 163 0 227.947 113.089 227.947 241.513 0 164.842-106.971 353.325-213.303 353.325-33.746 0-50.301-18.529-50.301-47.919 0-7.667 1.274-15.973 3.821-24.918-36.293 61.975-106.332 119.479-171.914 119.479-47.754 0-71.949-30.03-71.949-72.199 0-15.334 3.183-31.307 8.914-47.28Zm246.817-284.942c0 37.422-22.079 56.132-46.777 56.132-25.073 0-46.777-18.71-46.777-56.132s21.704-56.133 46.777-56.133c24.698 0 46.777 18.711 46.777 56.133Zm140.332.001c0 37.422-22.079 56.133-46.777 56.133-25.073 0-46.777-18.711-46.777-56.133 0-37.422 21.704-56.132 46.777-56.132 24.698 0 46.777 18.71 46.777 56.132Z",
    fill: "#FFFDF8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "phantom_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -0.001,
    width: 1200,
    height: 1200,
    rx: 600,
    fill: "#fff"
  })))));
};
export default SvgPhantom;